import React, { useState, useEffect } from 'react';
import { Alert, Button } from '@cloudscape-design/components';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function TrialBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const navigate = useNavigate();
  const { trialStatus } = useAuth();

  useEffect(() => {
    if (trialStatus.isTrialUser) {
      setShowBanner(true);
    } else {
      setShowBanner(false);
    }
  }, [trialStatus.isTrialUser]);

  if (!showBanner) {
    return null;
  }

  return (
    <div style={{ 
      width: '100%'
    }}>
      <Alert
        type="info"
        dismissible
        onDismiss={() => setShowBanner(false)}
        action={
          <Button onClick={() => {
            console.log('Trial banner button clicked, navigating to /payment-setup');
            navigate('/payment-setup');
          }}>
            Add Payment Method
          </Button>
        }
      >
        <strong>Trial Mode:</strong> You're exploring Recapify with trial credits. 
        Add a payment method for continued seamless access - you'll only be charged after your trial credits are used.
      </Alert>
    </div>
  );
}

export default TrialBanner;
